import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'charla-attachment-image',
    template: `
        <div class="modal-body">
            <img [src]="image_source" />
        </div>
    `,
    styles: [`
        div{
            text-align: center;
        }

        img {
            max-width: 90vw;
            max-height: 90vh;
        }
    `],
    imports: [CommonModule]
})
export class AttachmentImageComponent {

    @Input() image_source: string = "";
	constructor(public activeModal: NgbActiveModal) {

    }

}